import {IconSize, iconStrokeWidthBySize} from '../icon_types';

type WarningIconProps = {
  id?: string;
  className?: string;
  size: IconSize;
  color?: string;
};

const pathDsBySize = {
  '16': [
    'M5.24016 1.33333H10.7602L14.6668 5.24V10.76L10.7602 14.6667H5.24016L1.3335 10.76V5.24L5.24016 1.33333Z',
    'M8 5.33333V8',
    'M8 10.6667H8.0075',
  ],
  '24': [
    'M7.86 2H16.14L22 7.86V16.14L16.14 22H7.86L2 16.14V7.86L7.86 2Z',
    'M12 8V12',
    'M12 16H12.01',
  ],
  '32': [
    'M10.4798 2.66666H21.5198L29.3332 10.48V21.52L21.5198 29.3333H10.4798L2.6665 21.52V10.48L10.4798 2.66666Z',
    'M16 10.6667V16',
    'M16 21.3333H16.0125',
  ],
};

const WarningIcon = (props: WarningIconProps) => {
  const {id, className, size, color} = props;
  const paths = pathDsBySize[size];
  const colorOptions = color || 'currentColor' || '#1E1E20';

  return (
    <svg
      id={id}
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none">
      {paths?.map((d, index) => (
        <path
          key={index}
          d={d}
          stroke={colorOptions}
          strokeWidth={iconStrokeWidthBySize[size]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  );
};

export default WarningIcon;
